import { useContext, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ControllerMultiTextArea } from '@components/forms/invite-guest/controller-multi-text-area';
import { MultiOfferHeader } from '@components/forms/invite-guest/multi-offer-header';
import { HeaderEventFormSummary } from '@components/forms/multi-offer/header-summary';
import { Modal } from '@components/modals';
import { ModalStickyFooter } from '@components/modals/modal-sticky-footer';
import { CompanyAuthContext } from '@contexts/company-auth-context/company-auth-context';
import classNames from 'classnames';

import { SummaryFormModalContentProps, SummaryFormModalProps } from './summary-form-multi-modal.type';

export const SummaryFormMultiModalContent = ({
  event,
  offer,
  addons,
  quantity,
  selectedAddons,
  title,
  mainActionText,
  mainActionIcon,
  onContinue,
  handleClose,
}: SummaryFormModalContentProps) => {
  const { t } = useTranslation();
  const {
    formState: { isValid },
  } = useFormContext();

  const { role } = useContext(CompanyAuthContext);

  const Icon = mainActionIcon;

  return (
    <div className='relative max-h-[80vh] overflow-y-auto'>
      <HeaderEventFormSummary
        title={title}
        offer={offer}
        quantity={quantity}
        selectedAddons={selectedAddons}
        addons={addons}
        event={event}
      />
      <div className={classNames('flex flex-col gap-4 px-4 sm:px-20 pt-4 pb-6 sm:pb-12')}>
        <MultiOfferHeader
          instructionsTitle={t('invitations:inviteListInstructionsTitle')}
          instructionsDescription={t('invitations:inviteListInstructionsText')}
          formName='multiOfferText'
        />
        <ControllerMultiTextArea
          textareaPlaceholder={t('invitations:inviteListTextareaPlaceholder')}
          formName='multiOfferText'
          offer={offer}
          roleName={role?.name}
        />
      </div>
      <ModalStickyFooter
        primaryButtonText={
          <>
            {Icon && <Icon className='w-4 h-4 mr-2' />}{' '}
            <span className='flex items-center gap-2'>{mainActionText}</span>
          </>
        }
        onPrimaryButtonClick={onContinue}
        secondaryButtonText={t('common:discard')}
        onSecondaryButtonClick={handleClose}
        isSubmitDisabled={!isValid}
      />
    </div>
  );
};

export const SummaryFormMultiModal = ({ open, ...summaryFormContentProps }: SummaryFormModalProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(open);
  const handleClose = () => setIsOpen(false);
  return (
    <Modal isOpen={isOpen} handleClose={handleClose}>
      <SummaryFormMultiModalContent {...summaryFormContentProps} />
    </Modal>
  );
};
